import { BaseModal } from './BaseModal'
import { Plan } from '../../lib/plans'

type Props = {
  isOpen: boolean
  plan: Plan
  openPayment: (plan?: Plan) => void
}

export const OpenPaymentModal = ({ openPayment, isOpen, plan }: Props) => {
  const onClose = (plan?: Plan) => {
    openPayment(plan);
  }

  return (
    <BaseModal title="" isOpen={isOpen} handleClose={onClose}>
      <div className="p-2 flex flex-row">
				<button
          onClick={() => onClose(plan)}
      	  id="import-stats"
      	  type="button"
      	  className="inline-flex justify-center items-center text-center w-full rounded-md border border-transparent shadow-sm px-4 py-4 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm m-4">
        Purchase Polygonle+
      	</button>
      </div>
    </BaseModal>
		)
}
